import React from "react";
import { convertUTCDateLocal } from "../../../../../utils/convertionFunc";

const VITAL_COLUMN_DETAILS = {
  BP: { label: "Blood Pressure (mmHg)", accessor: "BP" },
  RR: { label: "Respiratory Rate (bpm)", accessor: "RR" },
  TP: { label: "Temperature (°F)", accessor: "TP" },
  HR: { label: "Heart Rate (bpm)", accessor: "HR" },
  PO: { label: "SpO2 (%)", accessor: "PO" },
  WE: { label: "Weight (Kg)", accessor: "WE" },
  HI: { label: "Height (cm)", accessor: "HI" },
  BMI: { label: "BMI (Kg/m²)", accessor: "BMI" },
};

function ConfiguredVitalTable({ data, rpmConfigVitalsList, vitalDisplayMap }) {
  let configuredVitalKeys = Object.entries(rpmConfigVitalsList || {})
    .filter(([key, value]) => value === 1 && vitalDisplayMap[key])
    .map(([key]) => vitalDisplayMap[key]);

  const hasBPS = configuredVitalKeys.includes("BPS");
  const hasBPD = configuredVitalKeys.includes("BPD");

  if (hasBPS && hasBPD) {
    configuredVitalKeys = configuredVitalKeys.filter(
      (code) => code !== "BPS" && code !== "BPD"
    );
    configuredVitalKeys.unshift("BP");
  }

  configuredVitalKeys = configuredVitalKeys.filter(
    (code) => code === "BP" || !!VITAL_COLUMN_DETAILS[code]
  );

  if (configuredVitalKeys.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center w-full">
        <p className="font-medium text-xl">No configured vitals to display!</p>
      </div>
    );
  }

  return (
    <div
      className={`min-w-full ${
        data ? "w-max" : "w-full"
      } rounded-lg flex justify-center`}
    >
      <table className="w-full overflow-scroll relative">
        <thead className="border">
          <tr>
            <th>Date & Time</th>
            {configuredVitalKeys.map((vitalCode) => (
              <th key={vitalCode}>{VITAL_COLUMN_DETAILS[vitalCode].label}</th>
            ))}
          </tr>
          {/* <tr className="bg-[#DEF3F2]">
            <td
              className="py-0.5"
              colSpan={configuredVitalKeys.length + 1}
            ></td>
          </tr> */}
        </thead>
        <tbody className="text-center">
          {data?.map((item, idx) => (
            <React.Fragment key={idx}>
              <tr className="border">
                <td>{convertUTCDateLocal(item.recordedDateTime) || "-"}</td>
                {configuredVitalKeys.map((vitalCode) => {
                  if (vitalCode === "BP") {
                    return (
                      <td key="BP">
                        {item.BPS ?? "-"} / {item.BPD ?? "-"}
                      </td>
                    );
                  }
                  const accessor = VITAL_COLUMN_DETAILS[vitalCode].accessor;
                  return <td key={vitalCode}>{item[accessor] ?? "-"}</td>;
                })}
              </tr>
              {/* <tr className="bg-[#DEF3F2]">
                <td
                  className="py-0.5"
                  colSpan={configuredVitalKeys.length + 1}
                ></td>
              </tr> */}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ConfiguredVitalTable;
